<template>
  <div class="search-container">
    <div class="search-content">
      <div class="search-top">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
          新建订单
      </div>
      <el-form class="form-container" @submit.native.prevent>
        <!-- <el-form-item class="input-list" label="业务人员"  prop="sales_ddname" v-if="user_type == 5"> 
          <el-select class="options-select" v-model="lab_sales_id" value-key="user_id" placeholder="请选择业务人员" clearable>
            <el-option
              v-for="item in sales"
              :key="item.user_id"
              :label="item.name"
              :value="item.user_id">
              {{item.name}}
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item class="input-list" label="公司名称" prop="company_name">
          <el-input type="text" placeholder="请输入公司名称回车选择" v-model="company_name" @keyup.enter.native = "searchCompany" style="width:18.5rem"></el-input><!--  @input="searchCompany" -->
        </el-form-item>
        <div class="company-container">
          <ul class="company" v-if = "companyList.length > 0">
            <li
              class="company-list"
              :class="{'company-select': index === company_index}"
              v-for="(item, index) in companyList"
              :key="index"
              @click="companyChoose(index)">{{item.company_name}}</li>
          </ul>
          <div class="none-content" v-else >
            <!-- <img src="~assets/icon_none.png" class="icon-none" alt=""> -->
            <p class="none-title">请输入搜索的公司名</p>
          </div>
        </div>
        <el-form-item class="btn-list" style="margin-top:1rem;margin-bottom:0rem">
          <el-button class="cancle-btn" @click="cancleDelete">取消</el-button>
          <el-button class="btn-save" @click="addNewOrder">下一步</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
import { getStore } from 'common/js/mUtils'
export default {
  data () {
    return {
      user_type: 0,
      sales: [],
      lab_sales_id: null,
      company_name: '', // 请输入公司名称
      companyList: [],
      company_index: 0
    }
  },
  created(){
    this.user_type = getStore('user_type')
    //this.initData()
    //console.log(this.user_type)
  },
  methods: {
    initData(){
      let that = this
      this.$api.getAllSalesman({
        type: 1
      }).then(
        res => {
          if (res.data.length > 0) {
            that.sales = res.data
          } else {
            that.sales = []
            that.$message({
              message: '没有市场人员信息，请添加。',
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }
      ).catch(e => {
        that.$message({
          message: `${e}`,
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    cancleDelete () { // 取消删除
      this.$emit('closeorder', 'cancle')
      this.$message({
        type: 'info',
        message: '取消添加订单！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    searchCompany () { // 输入框的 input ⌚事件
      let that = this
      if (that.company_name) {
        this.$api.searchCompany({
          company_name: that.company_name
        }).then(res => {
          if (res.data.length > 0) {
            that.companyList = res.data
          } else {
            that.companyList = []
            that.$message({
              message: '没有该公司请先添加',
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(e => {
          that.$message({
            message: `${e}`,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          message: '输入不能为空！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    companyChoose (index) { // 选择要创建订单的公司
      this.company_index = index
    },
    addNewOrder () {
      let that = this
      let index = this.company_index
      if (that.companyList.length > 0 && that.companyList[index].id) {
        this.$api.createOrder({
          id: that.companyList[index].id,
          lab_sales_id: that.lab_sales_id
        }).then(res => {
          if (res.data.msg == true) {
            that.$emit('closeorder', 'sure')
            that.$router.push({ path: `/orderAddDevice/${res.data.order_id}`})
          } else {
            that.$message({
              type: 'error',
              message: '创建订单失败',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(e => {
          that.$message({
            type: 'error',
            message: `${e}`,
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          message: '请选择要创建订单的公司',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      }
    }
  },
  destroyed () {
  }
}
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
.search-container
  position:fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(0, 0, 0, 0.2);
  z-index:10;
  display: flex;
  justify-content: center;
  align-items: center;
  .search-content
    background:#fff;
    z-index: 101;
    width: 26rem;
    padding: 0rem;
    border-radius: 0.4rem;
    position: relative;
    overflow:hidden;
    .search-top
      line-height: 3rem;
      background: #1D489E;
      color: #fff;
      font-size:0.8rem;
      text-align: center;
      font-weight:bold;
    .form-container
      border: 0;
      padding: 2rem;
      .input-list
        display: flex;
        margin-bottom: 1rem;
        &.is-error
          .el-form-item__content
            .el-input
              .el-input__inner
                border: 0.05rem solid #EF757A;
        .el-form-item__label
          color:#474747;
          font-size:0.7rem
          flex: 0 0 5rem;
          text-align: left;
        .el-form-item__content
          position:relative;
          height:2rem;
          flex: 1;
          .el-input
            height:2rem;
            .el-input__inner
              padding: 0 0.8rem;
              border: 0.05rem solid #cfcfcf;
          .el-form-item__error
            /* top:0.5rem; */
            left: 0.8rem;
            background:#fff;
            color:#EF757A;
      .btn-content
        width:100%;
        padding:0;
        margin-top:1rem;
        margin-bottom:0;
        .el-form-item__content
          display: flex;
          width:100%;
          .btn-list
            flex:1;
            height: 2rem;
            &.btn-save
              background:#1D489E;
              span
                color:#fff;
            &.cancle-btn
              background: #cfcfcf;
              color:#fff;
              span
                color:#fff;
      .company-container
        margin: 0 0 0 3.5rem;
        border: 0.05rem solid #cfcfcf;
        max-height: 10rem;
        overflow:hidden;
        .company
          overflow-y: auto;
          .company-list
            height: 2rem;
            line-height: 2rem;
            font-size:0.7rem;
            padding: 0 0.5rem;
            border-bottom: 0.05rem solid #cfcfcf;
            color: #666;
            &:last-child
              border:0;
            &.company-select
              color: #fff;
              background: #1D489E;
        .none-content
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 1rem 0;
          .none-title
            font-size: 0.7rem;
            color:#666;
    .close-icon
      position: absolute;
      top:0.5rem;
      right:0.5rem;
      color:#fff;
      font-size:1.2rem;
</style>
